import { qs, remove } from "@fluorescent/dom";

import { section } from "@/glow";
import ProductItem from "@/lib/product-item";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  recommendations: "[data-recommendations]",
};

section("recommended-products", {
  onLoad() {
    const { limit, productId, sectionId } = this.container.dataset;

    const content = qs(selectors.recommendations, this.container);
    if (!content) return;

    const requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;

    const request = new XMLHttpRequest();
    request.open("GET", requestUrl, true);

    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        let container = document.createElement("div");
        container.innerHTML = request.response;

        content.innerHTML = qs(selectors.recommendations, container).innerHTML;

        // Show section if recommendations
        if (content.innerHTML !== "") {
          remove(this.container, "hidden");
        }

        this.productItem = ProductItem(this.container);

        if (shouldAnimate(this.container)) {
          this.animateFeaturedCollection = animateStandard(
            this.container
          );
        }
      } else {
        // If request returns any errors remove the section markup
        this._removeSection();
      }
    };
    request.send();
  },

  _removeSection() {
    this.container.parentNode.removeChild(this.container);
  },

  onUnload() {
    this.animateFeaturedCollection?.destroy();
  },
});
